import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from '@/App'
/*
 * Округлый шрифт для заголовков и кнопок — он и задаёт игре тон.
 *
 * Пакетом, а не ссылкой на Google Fonts: файлы уезжают в сборку, стенд не
 * ходит за ними в интернет, и на закрытом контуре шрифт не пропадает.
 * Браузер скачает только нужные подмножества — кириллицу и латиницу.
 */
import '@fontsource-variable/nunito'
import '@/ui.css'
import { config } from '@/shared/config'
/*
 * Тема ставится атрибутом на <html> при загрузке модуля, а не эффектом
 * в компоненте: на странице она должна стоять с первого кадра. Импорт
 * поэтому явный — иначе модуль подтянулся бы только тогда, когда кто-то
 * впервые спросит тему, то есть при открытии настроек.
 */
import '@/features/game/useTheme'
import { rememberLanding } from '@/features/auth/landing'
import { initSentry, SentryErrorBoundary } from '@/sentry'

// До createRoot: иначе ошибки самого рендера в Sentry не попадут.
initSentry()

// Заголовок вкладки — из runtime-конфига, а не из index.html: один и тот же
// бандл ездит между стендами, а имя проекта приходит из ENV.
document.title = config.appName

// До любых переходов внутри игры: они переписывают адрес, и метка из
// рекламной ссылки пропала бы.
rememberLanding()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false },
  },
})

const container = document.getElementById('root')
if (!container) throw new Error('#root не найден в index.html')

createRoot(container).render(
  <StrictMode>
    <SentryErrorBoundary fallback={<p>Что-то сломалось. Обновите страницу.</p>}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </SentryErrorBoundary>
  </StrictMode>,
)
